module.exports = __webpack_public_path__ + "img/cajatacna.6903919.png";